const locale = "fr-FR";

export default function (d) {
    if (d) {
        const date = new Date(d);
        return date.toLocaleDateString(locale, { month: "2-digit", day: "2-digit", year: "numeric" });
    } else {
        return null;
    }
}
